<div class="unauthorized-page">
  <h1 class="unauthorized-title">401 Unauthorized</h1>
  <p class="unauthorized-text">You do not have permission to access this page.</p>
</div>
